export enum RoleEnum {
  SuperAdministrator = 0,
  Consultant = 1,
  PortalUser = 2,
  CallCenterAgent = 3,
  Partner = 4,
  Finance = 5,
  CallCenterManager = 6,
}
